// Bridges axios' response interceptor (outside the React tree) to the
// SmsQuietHoursDialog component (inside the React tree) so a 428 "quiet hours"
// response can pause the request, show the prompt, and resolve with the
// user's decision ("send_now" | "queue" | null if dismissed).
let handler = null;

export function registerQuietHoursHandler(fn) {
  handler = fn;
}

export function triggerQuietHoursPrompt(detail) {
  if (!handler) return Promise.resolve(null);
  return handler(detail);
}
